"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var react_1 = require("react");
var React = require("react");
var TetherComponentPortal_1 = require("./TetherComponentPortal");
function childrenPropType(_a, _propName, componentName) {
    var children = _a.children;
    var childCount = react_1.Children.count(children);
    if (childCount <= 0) {
        return new Error(componentName + " expects at least one child to use as the target element.");
    }
    else if (childCount > 2) {
        return new Error("Only a max of two children allowed in " + componentName + ".");
    }
}
var attachmentPositions = [
    'top left',
    'top center',
    'top right',
    'middle left',
    'middle center',
    'middle right',
    'bottom left',
    'bottom center',
    'bottom right'
];
var TetherComponent = /** @class */ (function (_super) {
    __extends(TetherComponent, _super);
    function TetherComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TetherComponent.prototype.update = function () {
        if (this.portalRef) {
            this.portalRef.updateTether();
        }
    };
    TetherComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, other = __rest(_a, ["children"]);
        var firstChild = null;
        var secondChild = null;
        // we use forEach because the second child could be null
        // causing children to not be an array
        react_1.Children.forEach(children, function (child, index) {
            if (index === 0) {
                firstChild = child;
                return false;
            }
            if (index === 1) {
                secondChild = child;
                return false;
            }
        });
        return (React.createElement(React.Fragment, null,
            React.cloneElement(firstChild),
            secondChild && (React.createElement(TetherComponentPortal_1.TetherComponentPortal, __assign({ ref: function (ref) {
                    _this.portalRef = ref;
                }, targetComponent: this, theme: this.props.theme }, other), React.cloneElement(secondChild)))));
    };
    TetherComponent.displayName = 'TetherComponent';
    TetherComponent.propTypes = {
        attachment: PropTypes.oneOf(attachmentPositions).isRequired,
        children: childrenPropType,
        className: PropTypes.string,
        classPrefix: PropTypes.string,
        classes: PropTypes.object,
        constraints: PropTypes.array,
        enabled: PropTypes.bool,
        id: PropTypes.string,
        offset: PropTypes.string,
        optimizations: PropTypes.object,
        renderElementTag: PropTypes.string,
        renderElementTo: PropTypes.any,
        style: PropTypes.object,
        targetAttachment: PropTypes.oneOf(attachmentPositions),
        targetModifier: PropTypes.string,
        targetOffset: PropTypes.string,
        theme: PropTypes.string.isRequired,
        rewriteTetherOptionsAfterMount: PropTypes.func
    };
    TetherComponent.defaultProps = {
        renderElementTag: 'div',
        renderElementTo: null,
        rewriteTetherOptionsAfterMount: function (options) { return options; }
    };
    return TetherComponent;
}(React.Component));
exports.TetherComponent = TetherComponent;
exports.default = TetherComponent;
//# sourceMappingURL=TetherComponent.js.map
